import React, { Fragment, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterOperations } from '../../../redux/filter';
import { incidentsOperations } from '../../../redux/incidentList';
import NarrativeQueryDialog from './NarrativeQueryDialog';
import FilterItemContainer from './FilterItemContainer';
import MultiSelect from './MultiSelect';
import NumericRange from './NumericRange';
import DateRange from './DateRange';
import DropDownSelect from './DropDownSelect';
import TextFilter from './TextFilter';
import JurisdictionalTextFilter from './JurisdictionalTextFilter';
import LocationFilter from './LocationFilter';
import Badge from 'material-ui/Badge';
import CircularProgress from 'material-ui/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';
import Popover from '@mui/material/Popover';
import IconButton from '@material-ui/core/IconButton';
import HelpIcon from '@mui/icons-material/Help';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import Typography from '@mui/material/Typography'; 
import { disableDrawMode, enableDrawMode, setSpatialFilterPolygon, zoomToPolygon } from '../../esri/mapHub';
import { getCountiesForState } from '../../../utils/incidentHelper';
import originFields from '../../../defaults/PointOfOriginFields.json'
import enums from '../../../defaults/Enums.json'

import './FiltersContainer.css';

import theme from '../../../muiTheme';

class FiltersContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      narrativeQueryDialogOpen: false,
      discoveryDateCommon: '',
      outDateCommon: '',
      modifiedDateCommon: '',
      anchorEl: null,
      popoverOpen: false,
      jurisdictionalUnitValid: null,
      protectingUnitValid: null
    };
  }

  onNarrativeQueryDialogClose = () => {
    this.setState({
      narrativeQueryDialogOpen: false
    });
  }

  clearPerimeterAcreage = () => {
    this.props.clearPerimeterAcreage();
  }

  onProtectingUnitChange = (unit) => 
  {
    if (!unit || unit === null || unit === '') 
    {
      this.setState({
        protectingUnitValid: null
      });
    } 
    if (unit && unit !== null && unit !== '') 
    {
      window.api.getUnitId(unit).then(unitIdResponse => 
      {
        const protectingUnitIdIsValid = (unitIdResponse && unitIdResponse.units && unitIdResponse.units.length > 0);
        this.setState({
          protectingUnitValid: protectingUnitIdIsValid
        });
      });
    }

    this.props.setPOOProtectingUnit(unit);
  }

  onJurisdictionalUnitChange = (unit) => 
  {
    if (!unit || unit === null || unit === '') 
    {
      this.setState({
        jurisdictionalUnitValid: null
      });
    } 
    if (unit && unit !== null && unit !== '') 
    {
      window.api.getUnitId(unit).then(unitIdResponse => 
      {
        const unitIdIsValid = (unitIdResponse && unitIdResponse.units && unitIdResponse.units.length > 0);
        this.setState({
          jurisdictionalUnitValid: unitIdIsValid
        });
      });
    }

    this.props.setPOOJurisdictionalUnit(unit);
  }

  handlePopoverClose = () => {
    this.setState({
      popoverOpen: false,
      anchorEl: null,
    });
  }

  openPopover = (event) => {
    event.preventDefault();

    this.setState({
      popoverOpen: true,
      anchorEl: event.currentTarget,
    });
  }
  setPerimeterAcreageLandowner = (landowner) => {
    this.props.setPerimeterAcreageLandowner(landowner);

    /* if (landowner && this.props.filter.perimeterAcreageOperator && this.props.filter.perimeterAcreageNumber) 
     {
       window.api.getPerimeterAcreageIds(landowner, this.props.filter.perimeterAcreageOperator, this.props.filter.perimeterAcreageNumber).then(response => 
       {
         this.props.setPerimeterAcreageIds(response);
       });
     } */
  }

  setPerimeterAcreageOperator = (operator) => {
    this.props.setPerimeterAcreageOperator(operator);

    /*if (this.props.filter.perimeterAcreageLandowner && operator && this.props.filter.perimeterAcreageNumber) 
    {
      window.api.getPerimeterAcreageIds(this.props.filter.perimeterAcreageLandowner, operator, this.props.filter.perimeterAcreageNumber).then(response => 
      {
        this.props.setPerimeterAcreageIds(response);
      });
    } */
  }

  setPerimeterAcreageNumber = (acreage) => {
    this.props.setPerimeterAcreageNumber(acreage);

    /*if (this.props.filter.perimeterAcreageLandowner && this.props.filter.perimeterAcreageOperator && acreage) 
    {
      window.api.getPerimeterAcreageIds(this.props.filter.perimeterAcreageLandowner, this.props.filter.perimeterAcreageOperator, acreage).then(response => 
      {
        this.props.setPerimeterAcreageIds(response);
      });
    } */
  }

  showNarrativePopup = () => {
    this.setState({
      narrativeQueryDialogOpen: true
    });
  }

  onSaveNarrativeFilter = (narrativeFilter, narrativeFilterState) => {
    this.props.setNarrativeFilter(narrativeFilter, narrativeFilterState);
    this.setState({
      narrativeQueryDialogOpen: false
    });
  }

  updateDataSourcesFilter = (args) => {
    if (!args) {
      this.props.clearDataSources();
    }
    else if (args.add) {
      this.props.addDataSource(args.value);
    }
    else {
      this.props.removeDataSource(args.value);
    }
  }

  handleMultiRootCheckboxChange = (event) => {
    const multiRootOnly = (event.target.checked);
    this.props.setMultiRoot(multiRootOnly);
  }

  updateInitialFireStrategyFilter = (args) => {
    if (!args) {
      this.props.clearInitialStrategy();
    }
    else if (args.add) {
      this.props.addInitialStrategy(args.value);
    }
    else {
      this.props.removeInitialStrategy(args.value);
    }
  }

  updateIrwinRelationshipsFilter = (args) => {
    debugger;
    if (!args) {
      this.props.clearIrwinRelationships();
    }
    else if (args.add) 
    {
      this.props.addIrwinRelationship(args.value);
    }
    else 
    {
      this.props.removeIrwinRelationship(args.value);
    }
  }
  //

  updateLandownerCategoryFilter = (args) => {
    if (!args) {
      this.props.clearLandownerCategory();
    }
    else if (args.add) {
      this.props.addLandownerCategory(args.value);
    }
    else {
      this.props.removeLandownerCategory(args.value);
    }
  }


  updateIncidentTypeCategoryFilter = (args) => {
    if (!args) {
      this.props.clearInitialType();
    }
    else if (args.add) {
      this.props.addInitialType(args.value);
    }
    else {
      this.props.removeInitialType(args.value);
    }
  }

  updateFireCauseFilter = (args) => {

    if (!args) {
      this.props.clearFireCause();
    }
    else if (args.add) {
      this.props.addFireCause(parseInt(args.value));
    }
    else {
      this.props.removeFireCause(parseInt(args.value));
    }
  }

  updateAcresRangeFilter = (args) => {
    if (!args) {
      this.props.clearFireAcreage();
    }
    else {
      this.props.setFireAcreage(args);
    }
  }

  updateDiscoveryDateFilter = (args) => {
    if (!args) {
      this.props.clearFireDiscoveryDates();
      this.setState({
        discoveryDateCommon: ''
      });
    }
    else {
      this.props.setFireDiscoveryDates(args);
      if (args.commonDate) {
        this.setState({
          discoveryDateCommon: args.commonDate
        });
      }
    }
  }

  updateOutDateFilter = (args) => {
    if (!args) {
      this.props.clearFireOutDates();
      this.setState({
        outDateCommon: ''
      });
    }
    else {
      this.props.setFireOutDates(args);
      if (args.commonDate) {
        this.setState({
          outDateCommon: args.commonDate
        });
      }
    }
  }

  updateModifiedDateFilter = (args) => {
    if (!args) {
      this.props.clearModifiedDates();
      this.setState({
        modifiedDateCommon: ''
      });
    }
    else {
      this.props.setModifiedDates(args);
      if (args.commonDate) {
        this.setState({
          modifiedDateCommon: args.commonDate
        });
      }
    }
  }

  clearFireDamageFilters = () => {
    this.props.setStructuresFilter(null);
    this.props.setInjuriesFilter(null);
    this.props.setFatalitiesFilter(null);
    this.props.setOtherStructuresDestroyedFilter(null);
    this.props.setResidencesThreatenedFilter(null);
    this.props.setOtherStructuresThreatenedFilter(null);
  }

  clearModifiedBySystemFilter = () => {
    this.props.setModifiedBySystemFilter(null);
  }

  clearCapabilityRequestsFilter = () => {
    this.props.setCapabilityRequestsFilter(null);
  }

  clearCreatedBySystemFilter = () => {
    this.props.setCreatedBySystemFilter(null);
  }

  clearCertificationFilter = () => {
    this.props.setCertifiedFilter(null);
  }

  clearGaccFilter = () => {
    this.props.setGaccFilter(null);
  }

  clearStateFilter = () => {
    this.props.setStateFilter(null);
    this.props.setCountyFilter(null);
  }

  handleUseExtentChange = (e, checked) => {
    this.props.setUseExtentFilter(checked);
  }

  drawToolSelected = (toolName) => {
    enableDrawMode({ drawAction: "polygon" })
      .then((args) => {
        this.props.setFilterGeometry(args.geometry);
        this.props.setActiveDrawTool(null);
      });
  }
  setGeometryFromShapefile = (polygon) => 
  { 
    this.props.setHasSpatialFilter(true);
    setSpatialFilterPolygon(polygon);
    zoomToPolygon(polygon);
  }

  drawToolCancelDraw = () => {
    disableDrawMode();
  }

  clearLocationFilter = () => {
    this.handleUseExtentChange(null, false);
    this.props.setFilterGeometry(null);
    this.props.setHasSpatialFilter(false);
    this.props.setSpatialFilterID(null);
    setSpatialFilterPolygon(null); 
    this.props.setActiveDrawTool(null);
  }


  render() {
    //const extentToggleStye = {color: (this.props.filter.useExtent ? theme.palette.canvasColor : theme.palette.secondaryTextColor)}
    let useExtentToggle = (
      <FilterItemContainer
        label="Location"
        filter={this.props.filter.geometry || this.props.filter.hasSpatialFilter}
        onClear={this.clearLocationFilter}
        children={(
          <div className="filter-item filter-item-location">
            <LocationFilter
              label="Select On Map"
              activeTool=""
              onToolSelected={this.drawToolSelected}
              setGeometryFromShapefile={this.setGeometryFromShapefile}
              onToolCancel={this.drawToolCancelDraw}
              onGeometryCleared={() => {
                this.props.setFilterGeometry(null);
                this.props.setHasSpatialFilter(false);
                this.props.setSpatialFilterID(null);
                setSpatialFilterPolygon(null);
              }} />
          </div>
        )}
      />

    );

    const fireCauseInfo = this.props.appConfig.fieldInfos.filter(info => { return info.name === originFields.fireCauseId })

    const fireCauseCodedValues = (fireCauseInfo.length === 1) ? fireCauseInfo[0].domain.codedValues : [];

    let fireCauseMultiSelect = (
      <FilterItemContainer
        label="Fire Cause"
        expanded={false}
        filter={!!this.props.filter.fireCauses.length}
        onClear={this.updateFireCauseFilter}
        children={(
          <MultiSelect
            selectedCodes={this.props.filter.fireCauses}
            codedValues={fireCauseCodedValues}
            onChange={this.updateFireCauseFilter}
          />
        )}
      />
    );

    let acreageNumericRange = (
      <FilterItemContainer
        label="Fire Acreage"
        expanded={false}
        filter={this.props.filter.fireAcresMax !== null || this.props.filter.fireAcresMin !== null}
        onClear={this.updateAcresRangeFilter}
        children={(
          <NumericRange
            max={this.props.filter.fireAcresMax}
            maxLabel="Max"
            min={this.props.filter.fireAcresMin}
            minLabel="Min"
            onRangeChange={this.updateAcresRangeFilter}
          />
        )}
      />
    );

    let fireDiscoveryDateRange = (
      <FilterItemContainer
        label="Fire Discovery Date"
        filter={this.props.filter.discoveryDateMax !== null || this.props.filter.discoveryDateMin !== null}
        onClear={this.updateDiscoveryDateFilter}
        children={(
          <DateRange
            max={this.props.filter.discoveryDateMax}
            maxLabel="Max"
            commonDate={this.state.discoveryDateCommon}
            min={this.props.filter.discoveryDateMin}
            minLabel="Min"
            onRangeChange={this.updateDiscoveryDateFilter}
          />
        )}
      />
    );

    let fireOutDateRange = (
      <FilterItemContainer
        label="Fire Out Date"
        expanded={false}
        filter={this.props.filter.outDateMax !== null || this.props.filter.outDateMin !== null}
        onClear={this.updateOutDateFilter}
        children={(
          <DateRange
            max={this.props.filter.outDateMax}
            maxLabel="Max"
            commonDate={this.state.outDateCommon}
            min={this.props.filter.outDateMin}
            minLabel="Min"
            onRangeChange={this.updateOutDateFilter}
          />
        )}
      />
    );

    let lastModifiedDateRange = (
      <FilterItemContainer
        label="Last Modified Date"
        expanded={false}
        filter={this.props.filter.modifiedDateMax !== null || this.props.filter.modifiedDateMin !== null}
        onClear={this.updateModifiedDateFilter}
        children={(
          <DateRange
            max={this.props.filter.modifiedDateMax}
            maxLabel="Max"
            commonDate={this.state.modifiedDateCommon}
            min={this.props.filter.modifiedDateMin}
            minLabel="Min"
            onRangeChange={this.updateModifiedDateFilter}
          />
        )}
      />
    );

    let modifiedSystem = (
      <FilterItemContainer
        label="Modified By System"
        expanded={false}
        filter={
          this.props.filter.modifiedBySystem !== null
        }
        onClear={this.clearModifiedBySystemFilter}
        children={(
          <div>
            <DropDownSelect
              label="System"
              multiSelect={true}
              onChange={this.props.setModifiedBySystemFilter}
              codedValues={[
                {
                  name: "CFCAD",
                  code: "cfcad"
                },
                {
                  name: "Dispatch Tracker",
                  code: "dispatchtracker"
                },
                {
                  name: "ERS",
                  code: 'ers'
                },
                {
                  name: "Firebeans",
                  code: "firebeans"
                },
                {
                  name: "FireCode",
                  code: 'firecode'
                },
                {
                  name: "fiResponse",
                  code: 'firesponse'
                },
                {
                  name: "Fireweb",
                  code: 'fireweb'
                },
                {
                  name: "ICS209",
                  code: "ics209"
                },
                {
                  name: "IFM",
                  code: "ifm"
                },
                {
                  name: "IFFRS",
                  code: "iffrs"
                },
                {
                  name: "INFORM Inspector",
                  code: "INFORM_Inspector"
                },
                {
                  name: "INFORM Mobile",
                  code: "INFORM_Mobile"
                },
                {
                  name: "IROC",
                  code: "IROC"
                },
                {
                  name: "IRWIN",
                  code: "irwin"
                },
                {
                  name: "IRWIN IMP",
                  code: "irwinimp"
                },
                {
                  name: "LACOCAD",
                  code: "lacocad"
                },
                {
                  name: "OCFACAD",
                  code: "ocfacad"
                },
                {
                  name: "WFDSS",
                  code: "wfdss"
                },
                {
                  name: "WIDNR",
                  code: "widnr"
                },
                {
                  name: "WildCAD",
                  code: "wildcad"
                },
                {
                  name: "WildCADe",
                  code: "wildcade"
                },
                {
                  name: "Wires",
                  code: "wires"
                },
              ]}
              value={this.props.filter.modifiedBySystem}
            />
          </div>
        )}
      />
    )

    let utcFilter = (
      <FilterItemContainer
        label="Incident Time Zone"
        expanded={false}
        filter={
          this.props.filter.utcOffset !== null
        }
        onClear={this.props.clearUtcOffsetFilter}
        children={(
          <div>
            <DropDownSelect
              label="Time Zone"
              multiSelect={false}
              onChange={this.props.setUtcOffsetFilter}
              codedValues={[
                {
                  name: "Hawaii–Aleutian",
                  code: "-10"
                },
                {
                  name: "Alaska",
                  code: "-9"
                },
                {
                  name: "Pacific",
                  code: '-8'
                },
                {
                  name: "Mountain",
                  code: "-7"
                },
                {
                  name: "Central",
                  code: '-6'
                },
                {
                  name: "Eastern",
                  code: "-5"
                },
                {
                  name: "Atlantic",
                  code: "-4"
                }
              ]}
              value={this.props.filter.utcOffset}
            />
          </div>
        )}
      />
    )

    let perimeterAcreageFilter = (
      <FilterItemContainer
        label="Acres by Ownership"
        expanded={false}
        filter={
          this.props.filter.perimeterAcreageLandowner !== null
        }
        onClear={this.clearPerimeterAcreage}
        children={(
          <div>
            <DropDownSelect
              label='Landowner'
              multiSelect={false}
              onChange={this.setPerimeterAcreageLandowner}
              codedValues={[
                {
                  name: "Bureau of Indian Affairs",
                  code: "BIA"
                },
                {
                  name: "Bureau of Land Management",
                  code: "BLM"
                },
                {
                  name: "Bureau of Reclamation",
                  code: 'BOR'
                },
                {
                  name: "Department of Defense",
                  code: "DOD"
                },
                {
                  name: "Department of Energy",
                  code: 'DOE'
                },
                {
                  name: "National Park Service",
                  code: "NPS"
                },
                {
                  name: "US Forest Service",
                  code: "USFS"
                },
                {
                  name: "US Fish and Wildlife Service",
                  code: "USFWS"
                },
                {
                  name: "Foreign Government",
                  code: "Foreign"
                },
                {
                  name: "Tribal Government (non-trust lands)",
                  code: "Tribal"
                },
                {
                  name: "City or Equivalent Government",
                  code: "City"
                },
                {
                  name: "County or Equivalent Government",
                  code: "County"
                },
                {
                  name: "State or Equivalent Government",
                  code: "State"
                },
                {
                  name: "Individual or Private Corporation",
                  code: "Private"
                },
                {
                  name: "Alaska Native Claims Settlement Act",
                  code: "ANCSA"
                },
                {
                  name: "Other Local",
                  code: "OthLoc"
                },
                {
                  name: "Other Federal",
                  code: "OthFed"
                }
              ]}
              value={this.props.filter.perimeterAcreageLandowner}
            />
            <DropDownSelect
              label='Operator'
              multiSelect={false}
              onChange={this.setPerimeterAcreageOperator}
              codedValues={[
                {
                  name: "greater than or equal to",
                  code: ">="
                },
                {
                  name: "less than or equal to",
                  code: "<="
                },
                {
                  name: "equals",
                  code: '='
                }
              ]}
              value={this.props.filter.perimeterAcreageOperator}
            />
            <TextFilter
              label="Acreage"
              value={this.props.filter.perimeterAcreageNumber}
              onChange={this.setPerimeterAcreageNumber}
            />
          </div>
        )}
      />
    )

    let createdBySystem = (
      <FilterItemContainer
        label="Created By System"
        expanded={false}
        filter={
          this.props.filter.createdBySystem !== null
        }
        onClear={this.clearCreatedBySystemFilter}
        children={(
          <div>
            <DropDownSelect
              label="System"
              multiSelect={true}
              onChange={this.props.setCreatedBySystemFilter}
              codedValues={[
                {
                  name: "CFCAD",
                  code: "cfcad"
                },
                {
                  name: "Dispatch Tracker",
                  code: "dispatchtracker"
                },
                {
                  name: "ERS",
                  code: 'ers'
                },
                {
                  name: "Firebeans",
                  code: "firebeans"
                },
                {
                  name: "FireCode",
                  code: 'firecode'
                },
                {
                  name: "fiResponse",
                  code: 'firesponse'
                },
                {
                  name: "Fireweb",
                  code: 'fireweb'
                },
                {
                  name: "ICS209",
                  code: "ics209"
                },
                {
                  name: "IFFRS",
                  code: "iffrs"
                },
                {
                  name: "IFM",
                  code: "ifm"
                },
                {
                  name: "INFORM Inspector",
                  code: "INFORM_Inspector"
                },
                {
                  name: "INFORM Inspector Bulk Upload",
                  code: "InspectorBulkUpload"
                },
                {
                  name: "INFORM Mobile",
                  code: "INFORM_Mobile"
                },
                {
                  name: "IROC",
                  code: "IROC"
                },
                {
                  name: "IRWIN",
                  code: "irwin"
                },
                {
                  name: "IRWIN IMP",
                  code: "irwinimp"
                },
                {
                  name: "LACOCAD",
                  code: "lacocad"
                },
                {
                  name: "OCFACAD",
                  code: "ocfacad"
                },
                {
                  name: "WFDSS",
                  code: "wfdss"
                },
                {
                  name: "WIDNR",
                  code: "widnr"
                },
                {
                  name: "WildCAD",
                  code: "wildcad"
                },
                {
                  name: "WildCADe",
                  code: "wildcade"
                },
                {
                  name: "WFMI",
                  code: "WFMI"
                },
                {
                  name: "Wires",
                  code: "wires"
                },
              ]}
              value={this.props.filter.createdBySystem}
            />
          </div>
        )}
      />
    )

    let fireDamages = (
      <FilterItemContainer
        label="Damages"
        expanded={false}
        filter={
          this.props.filter.structuresDestroyed !== null ||
          this.props.filter.injuries !== null ||
          this.props.filter.fatalities !== null ||
          this.props.filter.otherStructuresDestroyed !== null ||
          this.props.filter.residencesThreatened !== null ||
          this.props.filter.otherStructuresThreatened !== null
        }
        onClear={this.clearFireDamageFilters}
        children={(
          <div>
            <DropDownSelect
              multiSelect={false}
              label="Residences Destroyed"
              onChange={this.props.setStructuresFilter}
              codedValues={[
                {
                  name: "All",
                  code: null
                },
                {
                  name: "Yes",
                  code: true
                },
                {
                  name: "No",
                  code: false
                }
              ]}
              value={this.props.filter.structuresDestroyed}
            />
            <DropDownSelect
              label="Injuries"
              multiSelect={false}
              onChange={this.props.setInjuriesFilter}
              codedValues={[
                {
                  name: "All",
                  code: null
                },
                {
                  name: "Yes",
                  code: true
                },
                {
                  name: "No",
                  code: false
                }
              ]}
              value={this.props.filter.injuries}
            />
            <DropDownSelect
              label="Fatalities"
              multiSelect={false}
              onChange={this.props.setFatalitiesFilter}
              codedValues={[
                {
                  name: "All",
                  code: null
                },
                {
                  name: "Yes",
                  code: true
                },
                {
                  name: "No",
                  code: false
                }
              ]}
              value={this.props.filter.fatalities}
            />
            <DropDownSelect
              multiSelect={false}
              label="Other Structures Destroyed"
              onChange={this.props.setOtherStructuresDestroyedFilter}
              codedValues={[
                {
                  name: "All",
                  code: null
                },
                {
                  name: "Yes",
                  code: true
                },
                {
                  name: "No",
                  code: false
                }
              ]}
              value={this.props.filter.otherStructuresDestroyed}
            />
            <DropDownSelect
              multiSelect={false}
              label="Residences Threatened"
              onChange={this.props.setResidencesThreatenedFilter}
              codedValues={[
                {
                  name: "All",
                  code: null
                },
                {
                  name: "Yes",
                  code: true
                },
                {
                  name: "No",
                  code: false
                }
              ]}
              value={this.props.filter.residencesThreatened}
            />
            <DropDownSelect
              multiSelect={false}
              label="Other Structures Threatened"
              onChange={this.props.setOtherStructuresThreatenedFilter}
              codedValues={[
                {
                  name: "All",
                  code: null
                },
                {
                  name: "Yes",
                  code: true
                },
                {
                  name: "No",
                  code: false
                }
              ]}
              value={this.props.filter.otherStructuresThreatened}
            />
          </div>

        )}
      />
    )

    let gaccFilter = (
      <FilterItemContainer
        label="GACC"
        expanded={false}
        filter={this.props.filter.gacc !== null}
        onClear={this.clearGaccFilter}
        children={(
          <DropDownSelect
            label="GACC"
            multiSelect={true}
            onChange={this.props.setGaccFilter}
            codedValues={[
              {
                name: "AICC",
                code: "AICC"
              },
              {
                name: "EACC",
                code: "EACC"
              },
              {
                name: "ONCC",
                code: "ONCC"
              },
              {
                name: "GBCC",
                code: "GBCC"
              },
              {
                name: "OSCC",
                code: "OSCC"
              },
              {
                name: "NRCC",
                code: "NRCC"
              },
              {
                name: "NWCC",
                code: "NWCC"
              },
              {
                name: "RMCC",
                code: "RMCC"
              },
              {
                name: "SACC",
                code: "SACC"
              },
              {
                name: "SWCC",
                code: "SWCC"
              },
              {
                name: "N/A",
                code: "N/A"
              }
            ]}
            value={this.props.filter.gacc}
          />
        )}
      />
    )

    let stateFilter = (
      <FilterItemContainer
        label="State"
        expanded={false}
        filter={this.props.filter.state !== null ||
          this.props.filter.county !== null}
        onClear={this.clearStateFilter}
        children={(
          <div>
            <DropDownSelect
              label="State"
              onChange={this.props.setStateFilter}
              multiSelect={true}
              codedValues={[
                {
                  name: "Alabama",
                  code: "US-AL"
                },
                {
                  name: "Alaska",
                  code: "US-AK"
                },
                {
                  name: "Arizona",
                  code: "US-AZ"
                },
                {
                  name: "Arkansas",
                  code: "US-AR"
                },
                {
                  name: "California",
                  code: "US-CA"
                },
                {
                  name: "Colorado",
                  code: "US-CO"
                },
                {
                  name: "Connecticut",
                  code: "US-CT"
                },
                {
                  name: "Delaware",
                  code: "US-DE"
                },
                {
                  name: "Florida",
                  code: "US-FL"
                },
                {
                  name: "Georgia",
                  code: "US-GA"
                },
                {
                  name: "Hawaii",
                  code: "US-HI"
                },
                {
                  name: "Idaho",
                  code: "US-ID"
                },
                {
                  name: "Illinois",
                  code: "US-IL"
                },
                {
                  name: "Indiana",
                  code: "US-IN"
                },
                {
                  name: "Iowa",
                  code: "US-IA"
                },
                {
                  name: "Kansas",
                  code: "US-KS"
                },
                {
                  name: "Kentucky",
                  code: "US-KY"
                },
                {
                  name: "Louisiana",
                  code: "US-LA"
                },
                {
                  name: "Maine",
                  code: "US-ME"
                },
                {
                  name: "Maryland",
                  code: "US-MD"
                },
                {
                  name: "Massachusetts",
                  code: "US-MA"
                },
                {
                  name: "Michigan",
                  code: "US-MI"
                },
                {
                  name: "Minnesota",
                  code: "US-MN"
                },
                {
                  name: "Mississippi",
                  code: "US-MS"
                },
                {
                  name: "Missouri",
                  code: "US-MO"
                },
                {
                  name: "Montana",
                  code: "US-MT"
                },
                {
                  name: "Nebraska",
                  code: "US-NE"
                },
                {
                  name: "Nevada",
                  code: "US-NV"
                },
                {
                  name: "New Hampshire",
                  code: "US-NH"
                },
                {
                  name: "New Jersey",
                  code: "US-NJ"
                },
                {
                  name: "New Mexico",
                  code: "US-NM"
                },
                {
                  name: "New York",
                  code: "US-NY"
                },
                {
                  name: "North Carolina",
                  code: "US-NC"
                },
                {
                  name: "North Dakota",
                  code: "US-ND"
                },
                {
                  name: "Ohio",
                  code: "US-OH"
                },
                {
                  name: "Oklahoma",
                  code: "US-OK"
                },
                {
                  name: "Oregon",
                  code: "US-OR"
                },
                {
                  name: "Pennsylvania",
                  code: "US-PA"
                },
                {
                  name: "Rhode Island",
                  code: "US-RI"
                },
                {
                  name: "South Carolina",
                  code: "US-SC"
                },
                {
                  name: "South Dakota",
                  code: "US-SD"
                },
                {
                  name: "Tennessee",
                  code: "US-TN"
                },
                {
                  name: "Texas",
                  code: "US-TX"
                },
                {
                  name: "Utah",
                  code: "US-UT"
                },
                {
                  name: "Vermont",
                  code: "US-VT"
                },
                {
                  name: "Virginia",
                  code: "US-VA"
                },
                {
                  name: "Washington",
                  code: "US-WA"
                },
                {
                  name: "West Virginia",
                  code: "US-WV"
                },
                {
                  name: "Wisconsin",
                  code: "US-WI"
                },
                {
                  name: "Wyoming",
                  code: "US-WY"
                },
                {
                  name: "District of Columbia",
                  code: "US-DC"
                },
                {
                  name: "American Samoa",
                  code: "US-AS"
                },
                {
                  name: "Guam",
                  code: "US-GU"
                },
                {
                  name: "Northern Mariana Islands",
                  code: "US-MP"
                },
                {
                  name: "Puerto Rico",
                  code: "US-PR"
                },
                {
                  name: "United States Minor Outlying Islands",
                  code: "US-UM"
                },
                {
                  name: "Virgin Islands, U.S.",
                  code: "US-VI"
                }
              ]}
              value={this.props.filter.state}
            />
            <DropDownSelect
              multiSelect={this.props.filter.state && this.props.filter.state.length === 1}
              label="County"
              useArray={true}
              onChange={this.props.setCountyFilter}
              codedValues={getCountiesForState(this.props.filter.state)}
              value={this.props.filter.county} />
          </div>
        )}
      />
    )

    let certificationLevels = (
      <FilterItemContainer
        label="Incident Status"
        expanded={false}
        filter={this.props.filter.certified !== null}
        onClear={this.clearCertificationFilter}
        children={(
          <DropDownSelect
            label="Status"
            multiSelect={true}
            onChange={this.props.setCertifiedFilter}
            codedValues={[
              {
                name: "All",
                code: "ALL"
              },
              {
                name: "Certified",
                code: enums.incidentStatus.certified
              },
              {
                name: "Complete",
                code: enums.incidentStatus.complete
              },
              {
                name: "Incomplete",
                code: enums.incidentStatus.incomplete
              },
              {
                name: "Quarantined",
                code: enums.incidentStatus.conflict
              },
              {
                name: "Non-Quarantined",
                code: "IsNotQuarantined"
              }
            ]}
            value={this.props.filter.certified}
          />
        )}
      />
    )

    let sourceFilter = (
      <FilterItemContainer
        label="Data Sources"
        expanded={false}
        filter={!!this.props.filter.dataSources.length || this.props.filter.multiRootOnly}
        onClear={this.updateDataSourcesFilter}
        children={(
          <div>
            <MultiSelect
              label="Data Source"
              onChange={this.updateDataSourcesFilter}
              codedValues={[
                {
                  name: "IRWIN",
                  code: "1"
                },
                {
                  name: "WFMI",
                  code: "2"
                },
                {
                  name: "Bulk Upload",
                  code: "3"
                },
                {
                  name: "FireStat",
                  code: "4"
                },
                {
                  name: "FOD (Non Fed)",
                  code: "5"
                }
              ]}
              selectedCodes={this.props.filter.dataSources}
            />
            <FormControlLabel style={{ color: "white" }} control={
              <Checkbox
                style={{ marginLeft: "5px !important", color: "white" }}
                checked={this.props.filter.multiRootOnly}
                onChange={this.handleMultiRootCheckboxChange}
              />
            }
              label="Only Multi-Root Incidents"
            />
          </div>
        )}
      />
    )

    let initialFireStrategyFilter = (
      <FilterItemContainer
        label="Initial Fire Strategy"
        expanded={false}
        filter={!!this.props.filter.strategies.length}
        onClear={this.updateInitialFireStrategyFilter}
        children={(
          <MultiSelect
            label="Strategy"
            onChange={this.updateInitialFireStrategyFilter}
            codedValues={[
              {
                name: "Full Suppression",
                code: "Full Suppression"
              },
              {
                name: "Point Zone Protection",
                code: "Point Zone Protection"
              },
              {
                name: "Confine",
                code: "Confine"
              },
              {
                name: "Monitor",
                code: "Monitor"
              }
            ]}
            selectedCodes={this.props.filter.strategies}
          />
        )}
      />
    )

    let relationshipsFilter = (
      <FilterItemContainer
        label="Relationships"
        expanded={false}
        filter={!!this.props.filter.irwinRelationships.length}
        onClear={this.updateIrwinRelationshipsFilter}
        children={(
          <MultiSelect
            label="Relationships"
            onChange={this.updateIrwinRelationshipsFilter}
            codedValues={[
              {
                name: "Providing Response To",
                code: "1"
              },
              {
                name: "Complex",
                code: "2"
              },
              {
                name: "Potential Conflict",
                code: "3"
              },
              {
                name: "Merge",
                code: "4"
              },
              {
                name: "Prescribed Escape",
                code: "5"
              },
              {
                name: "Post-Fire",
                code: "6"
              }
            ]}
            selectedCodes={this.props.filter.irwinRelationships}
          />
        )}
      />
    )


    let incidentTypeCategoryFilter = (
      <FilterItemContainer
        label="Incident Category"
        expanded={false}
        filter={!!this.props.filter.categories.length}
        onClear={this.updateIncidentTypeCategoryFilter}
        children={(
          <MultiSelect
            label="Type"
            onChange={this.updateIncidentTypeCategoryFilter}
            codedValues={[
              {
                name: "Wildfire",
                code: "WF"
              },
              { name: "Incident Complex", code: "CX" },
              { name: "False Alarm", code: "FA" },
              {
                name: "Prescribed Fire",
                code: "RX"
              },
              {
                name: "Debris/Product Fire",
                code: "DF"
              },
              {
                name: "Structure Fire",
                code: "SF"
              },
              {
                name: "Vehicle Fire",
                code: "VF"
              },
              {
                name: "Preparedness/Preposition",
                code: "PP"
              },
              {
                name: "Incident/Event Support",
                code: "SU"
              },
              { name: "Out of Area Response", code: "OR" },
              {
                name: "Emergency Stabilization / BAER",
                code: "BR"
              },
              {
                name: "Fire Rehabilitation",
                code: "FR"
              },
              {
                name: "Non-Statistical/Other",
                code: "NS"
              }
            ]}
            selectedCodes={this.props.filter.categories}
          />
        )}
      />
    )


    let finalReportFilter = (
      <FilterItemContainer
        label="Final Report Narrative"
        expanded={false}
        filter={Boolean(this.props.filter.narrativeFilter)}
        onClear={this.props.setNarrativeFilter}
        children={
          (<div>
            <div
              className="filter-collapser"
              onClick={this.showNarrativePopup}>Edit
            </div>

            <NarrativeQueryDialog
              open={this.state.narrativeQueryDialogOpen}
              onClose={this.onNarrativeQueryDialogClose}
              filterForEdit={this.props.filter.narrativeFilterState}
              onSaveNarrativeFilter={this.onSaveNarrativeFilter}
            />
          </div>)
        }
      />
    )
    const showJurisdictionalIcon = this.state.jurisdictionalUnitValid !== null;
    const iconToShow = (showJurisdictionalIcon) ? ((this.state.jurisdictionalUnitValid) ? ( <CheckIcon color="success"/>) : ( <DoNotDisturbAltIcon color="error"/>)) : '';

    let jurisdictionalFilter = (
      <FilterItemContainer
        label="Jurisdiction"
        expanded={false}
        filter={(this.props.filter.incidentJurisdictionalAgency || this.props.filter.jurisdictionalUnit)}
        onClear={() => {
          this.props.setPOOIncidentJurisdictionalAgency(null);
          this.props.setPOOJurisdictionalUnit(null);
          //this.props.setPOOProtectingUnit(null);
          this.onJurisdictionalUnitChange(null);
        }}
        children={(
          <div>
            <TextFilter
              label="Jurisdictional Agency"
              value={this.props.filter.incidentJurisdictionalAgency}
              onChange={this.props.setPOOIncidentJurisdictionalAgency}
            />
            <JurisdictionalTextFilter
              label="Jurisdictional Unit"
              value={this.props.filter.jurisdictionalUnit}
              onChange={this.onJurisdictionalUnitChange}
              iconToShow={iconToShow}
            /> 
          </div>
        )} />
    )

    let uniquenessIndexFilter = (
      <FilterItemContainer
        label="Uniqueness Score"
        expanded={false}
        filter={(this.props.filter.uniqueness)}
        onClear={() => {
          this.props.setUniquenessFilter(null);
        }}
        children={(
          <div>
            <TextFilter
              label="Uniqueness Score Threshold"
              value={this.props.filter.uniqueness}
              onChange={this.props.setUniquenessFilter}
            />
          </div>
        )} />
    )

    let dispatchCenterFilter = (
      <FilterItemContainer
        label="Derived Dispatch Center"
        expanded={false}
        filter={(this.props.filter.dispatchCenterID)}
        onClear={() => {
          this.props.setDispatchCenterID(null);
        }}
        children={(
          <div>
            <TextFilter
              label="Dispatch Center ID"
              value={this.props.filter.dispatchCenterID}
              onChange={this.props.setDispatchCenterID}
            />
          </div>
        )} />
    )

    
    const showProtectingUnitIcon = this.state.protectingUnitValid !== null;
    const protectingIconToShow = (showProtectingUnitIcon) ? ((this.state.protectingUnitValid) ? ( <CheckIcon color="success"/>) : ( <DoNotDisturbAltIcon color="error"/>)) : '';

    let protectingUnitFilter = (
      <FilterItemContainer
        label="Protection"
        expanded={false}
        filter={(this.props.filter.pooProtectingAgency || this.props.filter.pooProtectingUnit)}
        onClear={() => {
          //this.props.setPOOProtectingUnit(null);
          this.onProtectingUnitChange(null);
          this.props.setPOOProtectingAgency(null);
        }}
        children={(
          <div>
             <TextFilter
              label="Protecting Agency"
              value={this.props.filter.pooProtectingAgency}
              onChange={this.props.setPOOProtectingAgency}
            />
            <JurisdictionalTextFilter
              label="Protecting Unit"
              value={this.props.filter.pooProtectingUnit}
              onChange={this.onProtectingUnitChange}
              iconToShow={protectingIconToShow}
            />
          </div>
        )} />
    )

    let landownerCategoryFields = [];
    landownerCategoryFields = this.props.appConfig.fieldInfos.filter(fieldInfo => {
      return fieldInfo.name === "POOLandownerCategory"
    })
    if (landownerCategoryFields.length > 0) {
      landownerCategoryFields = landownerCategoryFields[0].domain.codedValues
    }

    let landownerCategoryFilter = (
      <FilterItemContainer
        label="Landowner Category"
        expanded={false}
        filter={!!this.props.filter.landownerCategories.length}
        onClear={this.updateLandownerCategoryFilter}
        children={(
          <MultiSelect
            label=''
            selectedCodes={this.props.filter.landownerCategories}
            codedValues={landownerCategoryFields}
            onChange={this.updateLandownerCategoryFilter}
          />
        )} />
    )

    let filterHeaderContent;
    const currentDisplayed = this.props.incidentList.displayedIncidentsCount;
    const queryTotal = this.props.incidentList.queriedIncidentsTotal;
    const labelText = (queryTotal === currentDisplayed) ? 'Showing All ' + currentDisplayed + ' Incidents' : ' Showing ' + currentDisplayed + ' of ' + queryTotal + ' Incidents';
    //const incidentCount = (this.props.filter.useExtent) ? this.props.incidentList.visibleIncidents.length : this.props.incidentList.incidents.length
    if (this.props.filter.loading) {
      filterHeaderContent = (
        <span style={{ textAlign: 'center', width: '100%' }}><CircularProgress size={24} thickness={2}/></span>
      )
    }
    else if (this.props.filterVisible) {
      /*let filteredIncidents;
      if (this.props.filter.shouldFilterOnPerimeterAcreageIds) 
      { 
        if (this.props.filter.perimeterAcreageIds.length > 0) 
        {
          filteredIncidents = this.props.incidentList.visibleIncidents.filter(item => this.props.filter.perimeterAcreageIds.includes(item.attributes[originFields.fireOccurenceRecordID]));
        } 
        else 
        {
          filteredIncidents = [];
        }
      } */
      filterHeaderContent = (queryTotal !== currentDisplayed) ?
        (<Fragment>{labelText}<IconButton
          color="inherit"
          aria-label="close"
          onClick={this.openPopover}
          style={{ padding: "0px 0" }} >
          <HelpIcon fontSize="small" color="primary" style={{ padding: "0px 0" }} />
        </IconButton>
          <Popover
            open={this.state.popoverOpen}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            onClose={this.handlePopoverClose}>
            <Fragment>
              <Typography sx={{ p: 2 }}>Filter criteria matched {queryTotal} incidents, but only {currentDisplayed} are displayed in the map.</Typography>
              <Typography sx={{ p: 2 }}>Downloading incidents will return all {queryTotal} incidents.</Typography>
            </Fragment>
          </Popover>
        </Fragment>)
        :
        (<Fragment><span>{'\u00A0'}{labelText}</span></Fragment>);

    }
    else {
      let badgeIncidentCount = currentDisplayed;
      filterHeaderContent = (
        <Badge
          className="filter-header-badge-icon"
          style={{ padding: "12px 0", cursor: "pointer" }}
          badgeStyle={{ top: -2, right: -10 }}
          badgeContent={badgeIncidentCount}
          primary={true}
          onClick={this.props.toggleFilterCollapse} >
          <FilterIcon color={theme.palette.secondaryTextColor} />
        </Badge>
      )
    }

    let contents = (
      <div className="filter-panel">
        <div className="filter-header">
          {filterHeaderContent}
        </div>
        <div className="filter-content">
          {useExtentToggle}
          {sourceFilter}
          {certificationLevels}
          {gaccFilter}
          {stateFilter}
          {initialFireStrategyFilter}
          {relationshipsFilter}
          {incidentTypeCategoryFilter}
          {fireCauseMultiSelect}
          {acreageNumericRange}
          {fireDiscoveryDateRange}
          {fireOutDateRange}
          {lastModifiedDateRange}
          {modifiedSystem}
          {createdBySystem}
          {fireDamages}
          {perimeterAcreageFilter}
          {finalReportFilter}
          {jurisdictionalFilter}
          {dispatchCenterFilter}
          {protectingUnitFilter}
          {landownerCategoryFilter}
          {uniquenessIndexFilter}
          {utcFilter}
        </div>
        <div
          className="filter-collapser"
          onClick={this.props.resetFilters}>
          Reset Filters
        </div>
      </div>
    );

    return (contents)
  }
}

const mapStateToProps = state => ({
  map: state.map,
  auth: state.auth,
  appConfig: state.config,
  filter: state.filter,
  incidentList: state.incidentList
  // router: state.router
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...filterOperations,
    ...incidentsOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FiltersContainer)
